import styled from "styled-components";
import {GameJackpotBarContributionLabelDefaultBox} from "./game-jackpot-bar-contribution-label.default.box";

export const GameJackpotBarContributionLabelCasino777Box = styled(GameJackpotBarContributionLabelDefaultBox)<{isOptInStatus?: boolean}>`
    color: ${({theme, isOptInStatus}) => isOptInStatus ? '#671C2D' : theme.colors.brandSecondaryDark};
    
    ${({theme}) => theme.font.presets.ultra};

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.3rem;
    }
`;